import { useState, useEffect } from 'react';

function useCountDown({ hours = 0, minutes = 0 }, storageKey = 'countdown_target') {
  const [timeLeft, setTimeLeft] = useState('');

  // Helper to compute remaining time
  const getRemainingTime = (targetTime) => {
    const now = new Date();
    const diffMs = targetTime - now;

    if (diffMs <= 0) return "Time's up!";

    const totalMinutes = Math.floor(diffMs / (1000 * 60));
    const displayHours = Math.floor(totalMinutes / 60);
    const displayMinutes = totalMinutes % 60;
    const seconds = Math.floor((diffMs / 1000) % 60);

    return `${displayHours}h ${displayMinutes}m ${seconds}s`;
  };

  useEffect(() => {
    let targetTime;

    // Check localStorage for existing target time
    const stored = localStorage.getItem(storageKey);
    if (stored) {
      targetTime = new Date(stored);
    } else {
      targetTime = new Date();
      targetTime.setHours(targetTime.getHours() + hours);
      targetTime.setMinutes(targetTime.getMinutes() + minutes);
      localStorage.setItem(storageKey, targetTime.toISOString());
    }

    // Update immediately
    setTimeLeft(getRemainingTime(targetTime));

    const intervalId = setInterval(() => {
      const remaining = getRemainingTime(targetTime);
      setTimeLeft(remaining);

      if (remaining === "Time's up!") {
        clearInterval(intervalId);
        localStorage.removeItem(storageKey); // Optional: clear after countdown ends
      }
    }, 1000);

    return () => clearInterval(intervalId);
  }, [hours, minutes, storageKey]);

  return timeLeft;
}

export default useCountDown;